// Doctor profiles. Add/edit entries here — page renders dynamically.
export const DOCTORS = [
    {
        slug: "naresh-trehan",
        name: "Dr. Naresh Trehan",
        image:
            "https://res.cloudinary.com/dod7nmzyg/image/upload/v1776693754/621-profile-dr-naresh-trehan_rmot4p.png",
        qualification: "MBBS, MD, FRCS (USA)",
        specialty: "cardiology",
        specialtyLabel: "Senior Cardiac Surgeon",
        experience: "50+ years",
        hospital: "Medanta — The Medicity, Gurugram",
        designation: "Chairman & Managing Director, Medanta",
        bio: "One of India's most renowned cardiovascular surgeons and the founder of Medanta. Trained at NYU and a former Attending Surgeon at NYU Medical Center, Dr. Trehan has performed over 48,000 cardiac procedures across his career and pioneered minimally invasive cardiac surgery in India.",
        expertise: [
            "Coronary Artery Bypass (CABG)",
            "Heart Valve Repair & Replacement",
            "Robotic Cardiac Surgery",
            "Paediatric Cardiac Surgery",
            "Aortic Aneurysm Surgery",
        ],
        treatments: ["cabg", "valve-replacement", "tavr", "angioplasty", "pacemaker"],
        languages: ["English", "Hindi", "Punjabi"],
        awards: [
            { year: "2001", title: "Padma Shri — Government of India" },
            { year: "2009", title: "Padma Bhushan — Government of India" },
            { year: "2014", title: "Dr. B.C. Roy National Award" },
        ],
    },
    {
        slug: "sandeep-vaishya",
        name: "Dr. Sandeep Vaishya",
        image:
            "https://res.cloudinary.com/deq3rnrha/image/upload/v1776765947/Dr_Sandeep_yqxe15.jpg",
        qualification: "MBBS, MS (Surgery), MCh (Neurosurgery)",
        specialty: "neurology",
        specialtyLabel: "Senior Neurosurgeon",
        experience: "30+ years",
        hospital: "Fortis Memorial Research Institute, Gurugram",
        designation: "Executive Director — Neurosurgery, Fortis Memorial",
        bio: "An internationally acclaimed neurosurgeon with deep expertise in brachial plexus reconstruction, peripheral nerve surgery and complex brain & spine procedures. Has trained at leading centres in the UK and US and operates on patients flying in from across South Asia, Africa and the Middle East.",
        expertise: [
            "Brain Tumour Surgery",
            "Spinal Disorders & Minimally Invasive Spine",
            "Brachial Plexus & Peripheral Nerve Surgery",
            "Functional Neurosurgery (DBS)",
            "Skull Base Surgery",
        ],
        treatments: ["brain-tumour", "spine-surgery", "dbs", "spine-tumour"],
        languages: ["English", "Hindi"],
        awards: [
            { year: "2018", title: "Lifetime Achievement Award — Neurological Society of India" },
        ],
    },
    {
        slug: "hemant-sharma",
        name: "Dr. Hemant Sharma",
        image:
            "https://res.cloudinary.com/deq3rnrha/image/upload/v1776765967/Dr_Hemant_fo6sns.jpg",
        qualification: "MBBS, MS (Orthopaedics), Fellowship (Joint Replacement)",
        specialty: "orthopedics",
        specialtyLabel: "Senior Bone & Joint Surgeon",
        experience: "35+ years",
        hospital: "Marengo Asia Hospital, Gurugram",
        designation: "Director — Orthopaedics, Marengo Asia",
        bio: "A pioneer of computer-navigated and robotic joint replacement in northern India with over 25,000 joint replacements performed. Specialises in complex revision surgery and primary hip and knee arthroplasty.",
        expertise: [
            "Total Knee Replacement",
            "Total Hip Replacement",
            "Revision Joint Surgery",
            "Sports Medicine & Arthroscopy",
            "Spine Surgery",
        ],
        treatments: ["knee-replacement", "hip-replacement", "spine-surgery", "acl-reconstruction", "spine-surgery-tlif"],
        languages: ["English", "Hindi"],
        awards: [],
    },
    {
        slug: "rahul-bhargava",
        name: "Dr. Rahul Bhargava",
        image:
            "https://res.cloudinary.com/deq3rnrha/image/upload/v1776768950/Dr_Rahul_bnff92.jpg",
        qualification: "MBBS, MD, DM (Clinical Haematology)",
        specialty: "oncology",
        specialtyLabel: "Haematology & Bone Marrow Transplant",
        experience: "35+ years",
        hospital: "Fortis Memorial Research Institute, Gurugram",
        designation: "Director — Haematology & BMT, Fortis Memorial",
        bio: "Among India's most experienced clinical haematologists, Dr. Bhargava has performed thousands of bone marrow transplants, including allogeneic and haplo-identical procedures for thalassaemia, leukaemia and aplastic anaemia.",
        expertise: [
            "Bone Marrow Transplantation",
            "Leukaemia & Lymphoma Management",
            "Thalassaemia & Sickle Cell Disease",
            "Multiple Myeloma",
            "Aplastic Anaemia",
        ],
        treatments: ["bmt", "chemotherapy"],
        languages: ["English", "Hindi"],
        awards: [],
    },
    {
        slug: "vivek-vij",
        name: "Dr. Vivek Vij",
        image:
            "https://res.cloudinary.com/deq3rnrha/image/upload/v1778662464/Dr_Vivek_Vij_j6ydsx.jpg",
        qualification: "MBBS, MS (Surgery), Fellowship (Liver Transplant)",
        specialty: "gastroenterology",
        specialtyLabel: "Liver Transplant Surgeon",
        experience: "35+ years",
        hospital: "Fortis Memorial Research Institute, Gurugram",
        designation: "Director — Liver Transplant Programme, Fortis",
        bio: "A leading living-donor liver transplant surgeon with over 3,500 liver transplants performed. Has trained surgeons across South Asia, the Middle East and Eastern Europe.",
        expertise: [
            "Living-Donor Liver Transplant",
            "Deceased-Donor Liver Transplant",
            "Paediatric Liver Transplant",
            "Hepato-Pancreato-Biliary (HPB) Surgery",
            "Liver Cancer Surgery",
        ],
        treatments: ["liver-transplant"],
        languages: ["English", "Hindi"],
        awards: [],
    },
    {
        slug: "vipul-nanda",
        name: "Dr. Vipul Nanda",
        image:
            "https://res.cloudinary.com/deq3rnrha/image/upload/v1778956900/Dr_Vipul_Nanda_iwlsqs.jpg",
        qualification: "MBBS & MS (Gen Surgery) — AIIMS, New Delhi; MCh (Plastic Surgery) — PGI, Chandigarh",
        specialty: "cosmetic",
        specialtyLabel: "Senior Cosmetic & Plastic Surgeon",
        experience: "30+ years",
        hospital: "Fortis Memorial Research Institute, Gurugram",
        designation: "Director — Plastic & Reconstructive Surgery",
        bio: "Dr. Vipul Nanda, with over 30 years of experience, is a renowned name in the field of Plastic and Cosmetic Surgery. Affiliated with Fortis Hospital, Gurugram, he is a sought-after surgeon recognized for his expertise and excellent results. Dr. Nanda's academic journey began at the All India Institute of Medical Sciences (AIIMS) New Delhi, where he completed his MBBS and MS (General Surgery), followed by MCh in Plastic Surgery from PGI Chandigarh, and subsequently served as Senior Faculty at PGI, Chandigarh. He has over 50 publications in peer-reviewed journals.",
        expertise: [
            "Aesthetic Facial Surgery",
            "Body Contouring",
            "Breast Surgery",
            "Hair Transplant",
            "Reconstructive Surgery",
        ],
        treatments: [],
        languages: ["English", "Hindi"],
        awards: [],
    },
    {
        slug: "rachita-munjal",
        name: "Dr. Rachita Munjal",
        image:
            "https://res.cloudinary.com/deq3rnrha/image/upload/v1778956900/Dr_Rachita_dju198.jpg",
        qualification: "MBBS, MD (Obstetrics & Gynaecology), Fellowship in Reproductive Medicine",
        specialty: "fertility",
        specialtyLabel: "Fertility & IVF Specialist",
        experience: "15+ years",
        hospital: "Partner IVF Centre, Gurugram",
        designation: "Consultant — Reproductive Medicine & IVF",
        bio: "Dr. Rachita Munjal is an experienced Gynaecologist and dedicated Fertility & IVF specialist with clinical experience of 15+ years. She specializes in individualized protocols for best outcomes in female and male infertility treatments and is well known for successful treatment outcomes. Highly trusted by her patients for her ethical and compassionate approach combined with in-depth subject knowledge that leads to excellent pregnancy results. In her long and illustrious career, she has served at several hospitals including CK Birla Hospital Gurgaon, Medicover Fertility, Apollo Hospital and Sanjay Gandhi Memorial Hospital. Dr. Rachita has experience of more than 3,000 IVF cycles.",
        expertise: [
            "IVF / ICSI",
            "Ovulation Induction & IUI",
            "Donor Egg & Sperm Programmes",
            "Fertility Preservation",
            "Recurrent Pregnancy Loss",
        ],
        treatments: [],
        languages: ["English", "Hindi"],
        awards: [],
    },
    {
        slug: "vinod-raina",
        name: "Dr. Vinod Raina",
        image:
            "https://res.cloudinary.com/deq3rnrha/image/upload/v1778956718/Dr_Vinod_Raina_fe32pe.jpg",
        qualification:
            "MD (Medicine) — AIIMS, 1977; Senior Residency in Medicine & Haematology, AIIMS 1978–1980; MRCP (UK) 1987; FRCP (Edinburgh) 1994; FRCP (London) 2013; Clinical Research Fellow, Medical Oncology — Glasgow 1986–1989",
        specialty: "oncology",
        specialtyLabel: "Senior Medical Oncologist",
        experience: "40+ years",
        hospital: "Fortis Memorial Research Institute, Gurugram",
        designation: "Chairman — Medical Oncology",
        bio: "Dr. Vinod Raina is one of India's foremost Medical Oncologists with more than 40 years of experience. Until recently he was Professor and Head of Medical Oncology at AIIMS, where under his leadership the department performed the largest number of transplants in India for various cancers over the last decade — he has personally performed approximately 250 transplants. He brings tremendous research experience, having been Principal Investigator on approximately 50 projects at AIIMS over 23 years, and is also Co-Founder of the INDOX network.",
        expertise: [
            "Solid Tumour Oncology",
            "Haematological Malignancies",
            "Targeted Therapy",
            "Immunotherapy",
            "Clinical Trials",
        ],
        treatments: ["chemotherapy"],
        languages: ["English", "Hindi"],
        awards: [],
    },
    {
        slug: "vedant-kabra",
        name: "Dr. Vedant Kabra",
        image:
            "https://res.cloudinary.com/deq3rnrha/image/upload/v1778956718/Dr_Vedanta_Kabra_f4uhvq.jpg",
        qualification:
            "MBBS (BHU) 1995; MS (Gen Surgery, BHU) 1998; DNB (Gen Surgery) 1999; MRCS (Edin), Royal College of Surgeons of Edinburgh 2002",
        specialty: "oncology",
        specialtyLabel: "Senior Surgical Oncologist",
        experience: "25+ years",
        hospital: "Fortis Memorial Research Institute, Gurugram",
        designation: "Principal Director — Surgical Oncology",
        bio: "Dr. Vedant Kabra is Principal Director of Surgical Oncology at Fortis Memorial Research Institute, Gurugram. He received his surgical oncology training from Tata Memorial Hospital, Mumbai and the National Cancer Centre, Singapore. Dr. Kabra has experience of over 12,000 cancer surgeries and has successfully performed various complex onco-surgical procedures including robotic cancer surgery. He has been a faculty at various international and national conferences, has numerous papers and three book chapters to his credit, in addition to various awards for academic excellence.",
        expertise: [
            "Robotic Cancer Surgery",
            "Breast Oncology",
            "Head & Neck Oncology",
            "GI Oncology",
            "Gynae Oncology",
        ],
        treatments: ["robotic-cancer-surgery"],
        languages: ["English", "Hindi"],
        awards: [],
    },
    {
        slug: "amal-roy-chudhury",
        name: "Dr. Amal Roy Chudhury",
        image:
            "https://res.cloudinary.com/deq3rnrha/image/upload/v1778956718/Dr_Amal_Roy_q9vfx1.jpg",
        qualification: "MBBS, MD (Radiation Oncology)",
        specialty: "oncology",
        specialtyLabel: "Senior Radiation Oncologist",
        experience: "30+ years",
        hospital: "Fortis Memorial Research Institute, Gurugram",
        designation: "Director — Radiation Oncology",
        bio: "Dr. Amal Roy Chaudhoory has completed his MBBS and MD from Kasturba Medical College, Manipal. Thereafter he has worked at Rajiv Gandhi Cancer Institute and Max Hospital, Saket and Shalimar Bagh. Dr. Amal has been extensively trained in all the advanced technologies related to radiation oncology including IMRT, IGRT, gated and adaptive radiotherapy, stereotactic radiosurgery and stereotactic body radiotherapy. He has several publications in national and international journals to his credit and has participated in various national and international conferences and CMEs.",
        expertise: [
            "IMRT & IGRT",
            "Stereotactic Radiosurgery (SRS/SBRT)",
            "Brachytherapy",
            "Paediatric Radiotherapy",
            "Tumour Board Planning",
        ],
        treatments: ["radiation-therapy"],
        languages: ["English", "Hindi", "Bengali"],
        awards: [],
    },
];

export const getDoctor = (slug) => DOCTORS.find((d) => d.slug === slug);

export const getDoctorsBySpecialty = (specSlug) =>
    DOCTORS.filter((d) => d.specialty === specSlug);

export const getDoctorsByTreatment = (treatmentSlug) =>
    DOCTORS.filter(
        (d) => Array.isArray(d.treatments) && d.treatments.includes(treatmentSlug)
    );
